import _ from 'lodash';
import Inbox from 'models/location/inbox';

export default function(context) {
  return _.findLast(context.stores.locationHistory.get().history, entry => entry instanceof Inbox);
}
